import React, { useState } from 'react';

const PTReturnFiling = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with PT Return Filing.',
    website_hp: ''
  });

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with PT Return Filing.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              PT Return Filing
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Professional Tax Return Filing is a mandatory state-level compliance requirement for businesses and professionals. Timely filing ensures you avoid penalties, maintain good standing with state authorities, and stay compliant with employment regulations across different states in India.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">🛡️</span> Stay PT Compliant, Avoid Penalties
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Filing Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of PT Return Filing
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Professional Tax (PT) is a state-level tax levied on professions, trades, and employment by state governments in India. It applies to all individuals and businesses earning income from salary, profession, or trade.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                PT Return Filing is a mandatory compliance requirement that varies by state in terms of due dates, payment thresholds, and filing frequencies. Employers are responsible for deducting and remitting professional tax on behalf of their employees.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our comprehensive PT Return Filing service ensures timely compliance across all states, helping businesses avoid penalties and maintain good standing with state tax authorities.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Avoid Penalties:</strong> Timely filing prevents late fees, penalties, and legal consequences from state authorities.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Maintain Business Compliance:</strong> Stay compliant with state employment regulations and maintain good standing.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">State-Specific Expertise:</strong> Expert handling of different state regulations, due dates, and filing requirements.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Online Filing Convenience:</strong> Seamless digital filing through state government portals for faster processing.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Dedicated Compliance Tracking:</strong> Continuous monitoring of filing deadlines and regulatory changes.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Expert Handling of Variations:</strong> Manage different PT rules across multiple states where you operate.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Timely Reminder Services:</strong> Proactive alerts for upcoming filing deadlines and payment due dates.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with PT Return Filing." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for PT Return Filing
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "📍", title: "Consultation & State Analysis", desc: "Understand your business locations and applicable PT laws across different states." },
              { number: "02", icon: "📁", title: "Document Collection", desc: "Gather business registration, PAN, address proof, employee details, and previous returns." },
              { number: "03", icon: "👤", title: "PT Registration", desc: "Complete Professional Tax registration with state authorities if not already registered." },
              { number: "04", icon: "🧮", title: "Monthly/Quarterly Calculation", desc: "Compute professional tax liability based on employee salaries and state-specific slabs." },
              { number: "05", icon: "📝", title: "Return Preparation", desc: "Fill required state-specific PT return forms with accurate employee and payment details." },
              { number: "06", icon: "💳", title: "Payment Processing", desc: "Process professional tax payment through designated banks or online portals." },
              { number: "07", icon: "📤", title: "Online Submission", desc: "File PT returns through state government portals with payment acknowledgment." },
              { number: "08", icon: "🏆", title: "Acknowledgement & Compliance Certificate", desc: "Receive filing proof, payment receipts, and compliance certificate for your records." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Documents Required for PT Return Filing
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Compliance
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🆔", title: "Business PAN Card", desc: "PAN card of the business entity or proprietor for tax identification." },
              { icon: "📋", title: "Registration Certificate", desc: "Certificate of Incorporation, Partnership Deed, or other business registration proof." },
              { icon: "🏠", title: "Business Address Proof", desc: "Utility bills, rental agreement, or property documents for business location verification." },
              { icon: "📄", title: "Previous PT Returns", desc: "Previous professional tax returns and payment receipts, if applicable." },
              { icon: "👥", title: "Employee Details", desc: "Employee salary records, joining dates, and professional tax deduction details." },
              { icon: "🏦", title: "Bank Account Details", desc: "Business bank account information for payment processing and verification." },
              { icon: "✉️", title: "Authorization Letter", desc: "Authorization for consultant to file returns on behalf of the business." },
              { icon: "📊", title: "Monthly Salary Register", desc: "Detailed salary register showing professional tax deductions for each employee." },
              { icon: "🛡️", title: "PT Registration Certificate", desc: "Professional Tax Registration Certificate issued by state authorities." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "🏆", title: "PT Registration Certificate", desc: "Professional Tax Registration Certificate from state authorities for new registrations." },
              { icon: "✅", title: "Filed Return Acknowledgements", desc: "Official acknowledgements and receipts for all filed PT returns from state portals." },
              { icon: "💳", title: "Payment Receipts", desc: "Complete set of payment receipts and challans for professional tax payments made." },
              { icon: "📅", title: "Compliance Calendar", desc: "State-wise compliance calendar with all upcoming PT filing deadlines and due dates." },
              { icon: "🔔", title: "Ongoing Support Services", desc: "Reminder services for future filings, state-specific compliance advisory, regulatory updates monitoring, multi-state compliance management" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      PT Return Filing FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "Who needs to pay professional tax?", 
                    answer: "All businesses, professionals, and individuals earning income from salary, profession, or trade above state-specified thresholds are required to pay professional tax." 
                  },
                  { 
                    question: "How often should PT returns be filed?", 
                    answer: "Filing frequency varies by state - it can be monthly, quarterly, or half-yearly. Most states require monthly returns for businesses with employees." 
                  },
                  { 
                    question: "What are the penalties for late filing?", 
                    answer: "Penalties include late filing fees (varies by state), interest on due amount, and in severe cases, legal action or prosecution by state authorities." 
                  },
                  { 
                    question: "Is professional tax applicable nationwide?", 
                    answer: "Most states have professional tax legislation, but rates, rules, and exemption limits vary significantly across different states in India." 
                  },
                  { 
                    question: "Can we file PT returns for multiple states?", 
                    answer: "Yes, we handle PT compliance across all states where your business operates, managing different due dates and filing requirements." 
                  },
                  { 
                    question: "What is the due date for PT return filing?", 
                    answer: "Due dates vary by state, typically falling between the 15th and 30th of the following month. We provide state-specific deadline tracking." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready for PT Return Filing?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of experts simplify your professional tax compliance across all states.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our PT Compliance Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default PTReturnFiling;